document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('root');
  if (!root) return;

  // Estado: Español e Inglés
  window.captions = [
    { time: 1, text: "EL PROCESO ES PARTE DEL [PROPÓSITO]", eng: "THE PROCESS IS PART OF THE [PURPOSE]" },
    { time: 5, text: "EN EL SILENCIO, [DIOS] HABLA", eng: "IN THE SILENCE, [GOD] SPEAKS" },
    { time: 9, text: "CRECIMIENTO ES [ENTREGA]", eng: "GROWTH IS [SURRENDER]" }
  ];

  root.innerHTML = `
    <div id="studio-core-container">
      <div id="header-patience">PATIENCE</div>
      <div id="ui-controls">
        <h1>STUDIO CORE</h1>
        <button id="toggle-ui">OCULTAR INTERFAZ</button>
      </div>
      <div id="main-layout">
        <div id="video-area" onclick="window.togglePlay()">
          <!-- Se eliminó 'muted' para permitir audio controlado -->
          <video id="main-video" playsinline preload="auto">
            <source src="https://cdn.shopify.com/videos/c/o/v/5a87467fd15348688a522b8da038e170.mov" type="video/mp4">
          </video>
          <div id="progress-bar"><div id="progress-fill"></div></div>
          <button id="unmute-btn" onclick="event.stopPropagation(); window.activateSound()">🔊 ACTIVAR SONIDO</button>
          <div id="caption-display"></div>
          <div id="caption-display-eng"></div>
        </div>
        <div id="editor-panel">
          <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:10px;">
            <h2 style="font-size: 0.9rem; color: #aaa;">TIMELINE DE CAPTIONS</h2>
            <button id="add-clip-btn">+ AÑADIR CLIP</button>
          </div>
          <div id="editor-fields"></div>
        </div>
      </div>
    </div>
  `;

  const video = document.getElementById('main-video');
  const captionDisplay = document.getElementById('caption-display');
  const captionDisplayEng = document.getElementById('caption-display-eng');
  const progressFill = document.getElementById('progress-fill');
  const unmuteBtn = document.getElementById('unmute-btn');
  let lastCaptionText = "";

  const grammerMap = {
      "DIOS": "yellow", "GOD": "yellow", "PROCESO": "yellow", "PROCESS": "yellow", 
      "PROPÓSITO": "yellow", "PURPOSE": "yellow", "SILENCIO": "yellow", "SILENCE": "yellow",
      "HABLA": "green", "SPEAKS": "green", "ES": "green", "IS": "green", 
      "CRECIMIENTO": "green", "GROWTH": "green", "ENTREGA": "green", "SURRENDER": "green",
      "PARTE": "red", "PART": "red"
  };

  const applyColors = (text) => {
    return text.split(' ').map(word => {
      const cleanWord = word.replace(/[^\w]/g, "").toUpperCase();
      if (grammerMap[cleanWord]) {
        return `<span class="highlight-block ${grammerMap[cleanWord]}">${word}</span>`;
      }
      return `<span>${word}</span>`;
    }).join(' ');
  };

  window.togglePlay = () => { 
    if (video.paused) {
      video.play().catch(e => console.log("Play pausado por política de navegador"));
    } else {
      video.pause();
    }
  };

  window.activateSound = () => { 
    video.muted = false; 
    video.volume = 1.0; 
    unmuteBtn.style.display = 'none'; 
    video.play(); 
  };

  window.seekTo = (time) => { video.currentTime = time; video.play(); };

  window.renderEditor = () => {
    const container = document.getElementById('editor-fields');
    container.innerHTML = '';
    window.captions.sort((a, b) => a.time - b.time).forEach((c, i) => {
      const row = document.createElement('div');
      row.className = "caption-row";
      row.onclick = () => window.seekTo(c.time);
      row.innerHTML = `
        <div style="font-size: 0.6rem; color: #444;">${c.time.toFixed(1)}s</div>
        <div style="flex-grow:1; display:flex; flex-direction:column; gap:5px;">
            <input type="text" value="${c.text}" oninput="window.captions[${i}].text = this.value" placeholder="ES">
            <input type="text" value="${c.eng}" oninput="window.captions[${i}].eng = this.value" placeholder="EN">
        </div>
        <button onclick="event.stopPropagation(); window.captions.splice(${i},1); window.renderEditor();">✕</button>
      `;
      container.appendChild(row);
    });
  };

  window.addCaption = () => {
    window.captions.push({ time: video.currentTime, text: "NUEVO TEXTO", eng: "NEW TEXT" });
    window.renderEditor();
  };

  video.addEventListener('timeupdate', () => {
    if (video.duration) {
        progressFill.style.width = (video.currentTime / video.duration) * 100 + "%";
    }
    const active = window.captions.find(c => video.currentTime >= c.time && video.currentTime < c.time + 3);
    
    if (active && lastCaptionText !== active.text) {
      lastCaptionText = active.text;
      captionDisplay.innerHTML = applyColors(active.text);
      captionDisplayEng.innerHTML = active.eng;
      captionDisplay.classList.add('active');
      captionDisplayEng.classList.add('active');
    } else if (!active && lastCaptionText !== "") {
      captionDisplay.classList.remove('active');
      captionDisplayEng.classList.remove('active');
      lastCaptionText = "";
    }
  });

  document.getElementById('add-clip-btn').addEventListener('click', window.addCaption);
  document.getElementById('toggle-ui').addEventListener('click', () => {
    const panel = document.getElementById('editor-panel');
    panel.style.display = panel.style.display === 'none' ? 'block' : 'none';
  });

  window.renderEditor();
});